import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"

import { CustomAttributeDefinitionFormProps } from "../../../../common/types"
import ProductCustomAttributeDefintion from "../../../../state/product-custom-attributes/CustomAttributeDefinition"
import CustomAttributesDefinitionInput from "./components/CustomAttributesDefinitionInput"

const CustomAttributeDefinitionForm = (props: CustomAttributeDefinitionFormProps) => {
    const createProductAttributeDefns = (): ProductCustomAttributeDefintion[] => {
        if (props.customAttributeDefinitions && props.customAttributeDefinitions.length > 0) {
            return props.customAttributeDefinitions.map(i => new ProductCustomAttributeDefintion(i))
        }
        return []
    }
    const productAttributesDefns: ProductCustomAttributeDefintion[] = createProductAttributeDefns()

    return !props.isLoading && <>
        <div className="mb-1 row">
            <label className="col-12 col-form-label custom-form-label strong">
                <FormattedMessage
                    id="product.form.edit.product_custom_attributes"
                    defaultMessage="Custom Attributes"
                />
            </label>
        </div>
        <CustomAttributesDefinitionInput
            isLoading={props.isLoading}
            customAttributeDefinitions={productAttributesDefns}
            onCustomAttributeDefnChange={props.onCustomAttributeDefnChange}
            onError={props.onError}
            isError={props.isError}
        />
        <small className="form-text text-muted">
            <FormattedMessage
                id="product.form.edit.pruoduct_custom_attributes_description"
                defaultMessage={"Add attributes to line items, both you and the customer can customize. " +
                    "It is useful to capture additional information about a product."}
            />
        </small>
    </>
}

export default injectIntl(CustomAttributeDefinitionForm)


// WEBPACK FOOTER //
// ./src/product/form/components/CustomAttributesDefinition/CustomAttributeDefinitionForm.tsx